import type { RotationOffsets } from '../types';
import apiRequest from './apiRequest';

export type CharacterGenerationUploadStatus =
  | 'ADJUSTMENT_FAILED'
  | 'AUTORIGGING_IN_PROGRESS'
  | 'COMPLETE'
  | 'FAILED'
  | 'NEEDS_VALIDATION'
  | 'PENDING'
  | 'RETARGETING_IN_PROGRESS';

export type CharacterGenerationGeneratedStatus =
  | 'QUEUED'
  | '3D_CONVERT_QUEUED'
  | '3D_CONVERT_STARTED'
  | '3D_CONVERT_COMPLETE'
  | '3D_CONVERT_FAILED';

export type CharacterGenerationBatchItem = {
  characterID: string;
  uploadStatus: CharacterGenerationUploadStatus | string;
  generatedStatus?: CharacterGenerationGeneratedStatus | string;
  errorMessage?: string;
  characterName: string;
  characterDescription?: string;
  fileExtension?: string;
  createdAt: string;
  createdBy: string;
  characterFileURL?: string | null;
  /** Rigged character.fbx presigned URL when the deliverable exists (≈1h expiry). */
  characterFbxURL?: string | null;
  thumbnailURL?: string | null;
  /** Selected source image used to generate the character, distinct from its rendered thumbnail. */
  referenceImageURL?: string | null;
  configURL?: string | null;
  tempConfigURL?: string | null;
  baseFbxURL?: string | null;
  baseGlbURL?: string | null;
  estimatedSecondsWaitTime?: number;
  rotationOffsets?: RotationOffsets;
};

export type CharacterGenerationListByBatchResponse = {
  items: CharacterGenerationBatchItem[];
  nextToken?: string;
};

export default async function getCharacterGenerationsByBatch(
  batchID: string,
  apiKey: string,
  options?: { limit?: number; nextToken?: string },
) {
  const params = new URLSearchParams();
  if (options?.limit !== undefined) {
    params.set('limit', String(options.limit));
  }
  if (options?.nextToken) {
    params.set('nextToken', options.nextToken);
  }
  const query = params.toString();

  return await apiRequest<CharacterGenerationListByBatchResponse>(
    'external-mogen',
    `/characters/batches/${encodeURIComponent(batchID)}${query ? `?${query}` : ''}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
